import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { usePrefetchMasonryNode } from "hooks/use-prefetch-masonry-node.hook";
import { SelfCollectionModalCard } from "./self-collection-modal-card.component";

/**
 * Cancellation confirmation modal (KIT-06). Reached when the user taps
 * "Cancel Order" on the Home Self-Collection Kit status tile. Renders
 * the BE-driven Masonry tree at `selfCollection$cancellation$root`.
 *
 * BE follow-up: masonry root delivery tracked separately with Egor.
 */
export const SelfCollectionCancellationPage = () => {
  usePrefetchMasonryNode(MASONRY.ROOT_NODE_ID_SELF_COLLECTION_ORDER_CANCELLED);

  usePageViewAnalytics({ screen_name: "Self Collection Cancellation" });
  const { formatMessage } = useIntl();

  useDocumentTitle(formatMessage({ id: "STR_SELF_COLLECTION_CANCELLATION" }));

  return (
    <SelfCollectionModalCard>
      <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_SELF_COLLECTION_CANCELLATION} />
    </SelfCollectionModalCard>
  );
};
